export default __webpack_public_path__ + "static/single-step-dark-1e6f9b29a046c5a2cecb2fa3bc337a98378d45cfb505dece23bd823f5c5b4a0e.png";